import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";

const ColumnChartStatistics = ({ siteList = [], notificationList = [], chartLoader }) => {
  const [chartOptions, setChartOptions] = useState({
    series: [],
    options: {
      chart: {
        type: "bar",
        height: 350,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          endingShape: "rounded",
        },
      },
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories: [],
      },
      colors: [
        "#C681ED", // Base purple
        "#D199F1", // Slightly lighter
        "#DCB2F5", // Medium light
        "#E6CAFA", // Soft lavender
        "#F1E3FE"  // Very light purple
      ],
      legend: {
        position: "bottom",
      },
    },
  });

  useEffect(() => {
    if (siteList.length && notificationList.length) {
      setChartOptions((prev) => ({
        ...prev,
        series: [
          {
            name: "Queries",
            data: notificationList,
          },
        ],
        options: {
          ...prev.options,
          xaxis: {
            categories: siteList,
          },
        },
      }));
    }
  }, [siteList, notificationList]);

  return (
    <div className="p-2">
      <h5 className="fw-bold mb-1 text-center w-100 mt-2">Notification Chart</h5>
      {chartLoader ?
        <div
          className="hstack justify-content-center"
          style={{ height: "calc(100vh - 500px)" }}
        >
          <PageLoader/>
        </div>
        :
        chartOptions.series.length > 0 && (
          <ReactApexChart
            options={chartOptions.options}
            series={chartOptions.series}
            type="bar"
            height={302}
          />
        )}
    </div>
  );
};

export default ColumnChartStatistics;